import counterpart from 'counterpart';
import { initCommonTranslate } from 'Utils/languages';

export function getFinancialsSectionData() {
  initCommonTranslate();
  return {
    dataColumns: [
      {
        name: counterpart('globalTranslate.timeline.adjustments'),
        displayType: 'ADJUSTMENTS',
        columnKey: 'ledgerAccount',
      },
      {
        name: counterpart('globalTranslate.timeline.amount'),
        displayType: 'CURRENCY',
        columnKey: 'amount',
      },
      {
        name: counterpart('globalTranslate.timeline.date'),
        displayType: 'DATE',
        columnKey: 'date',
      },
    ],
    settlementColumns: [
      {
        name: counterpart('globalTranslate.timeline.company'),
        displayType: 'STRING',
        columnKey: 'Company',
      },
      {
        name: counterpart('globalTranslate.timeline.bankId'),
        displayType: 'STRING',
        columnKey: 'Bank',
      },
    ]
  }
}

export function getMerchantAdviceSectionData() {
  initCommonTranslate();
  return {
    dataColumns: [
      {
        name: counterpart('globalTranslate.timeline.description'),
        displayType: 'LETTER',
        columnKey: 'letterName',
      },
      {
        name: counterpart('globalTranslate.timeline.stage'),
        displayType: 'STRING',
        columnKey: 'stage',
      },
      {
        name: counterpart('globalTranslate.timeline.date'),
        displayType: 'DATE',
        columnKey: 'date',
      }
    ],
    messageData: {
      name: counterpart('globalTranslate.timeline.messageToMerchant'),
      substituteField: counterpart('globalTranslate.timeline.followUp'),
      displayType: 'STRING',
      columnKey: 'MerchantMessage',
      optionalName: 'Merchant Preferred Language'
    }

  }
}

export function getStageCloseSectionData() {
  initCommonTranslate();
  return {
    eventCode: 'STAGE_CLOSE',
    isVertical: true,
    dataColumns: [
      {
        name: counterpart('globalTranslate.timeline.casestageid'),
        displayType: 'CASESTAGEID',
        columnKey: 'stageId',
      },
      {
        name: counterpart('globalTranslate.timeline.stage'),
        displayType: 'STAGE',
        columnKey: '',
      },
      {
        name: counterpart('globalTranslate.timeline.issuerresponseduedate'),
        displayType: 'IssuerResponseDueDate',
        columnKey: 'IssuerResponseDueDate',
      },
      {
        name: counterpart('globalTranslate.timeline.disposition'),
        displayType: 'DISPOSITION',
        columnKey: 'disposition',
      }
    ],
    messageData: {
      name: counterpart('globalTranslate.timeline.reasonForClosing'),
        displayType: 'NOTE',
        columnKey: 'CloseCaseReason',
    }
  }
}
export function getStageCloseSectionDataForCardBrand() {
  initCommonTranslate();
  return {
    eventCode: 'STAGE_CLOSE',
    isVertical: true,
    dataColumns: [
      {
        name: counterpart('globalTranslate.timeline.casestageid'),
        displayType: 'CASESTAGEID',
        columnKey: 'stageId',
      },
      {
        name: counterpart('globalTranslate.timeline.stage'),
        displayType: 'STAGE',
        columnKey: '',
      },
      {
        name: counterpart('globalTranslate.timeline.cardBrandResponseDueDate'),
        displayType: 'cardBrandResponseDueDate',
        columnKey: 'cardBrandResponseDueDate',
      },
      {
        name: counterpart('globalTranslate.timeline.disposition'),
        displayType: 'DISPOSITION',
        columnKey: 'disposition',
      }
    ],
    messageData: {
      name: counterpart('globalTranslate.timeline.reasonForClosing'),
        displayType: 'NOTE',
        columnKey: 'CloseCaseReason',
    }
  }
}

export function getStageSectionData() {
  initCommonTranslate();
  return {
    eventCode: 'NEW_CASE_STAGE',
    isVertical: true,
    dataColumns: [
      {
        name: counterpart('globalTranslate.timeline.stage'),
        displayType: 'STAGE',
        columnKey: '',
      },
      {
        name: counterpart('globalTranslate.timeline.reasonCode'),
        displayType: 'REASON_CODE',
        columnKey: 'DisputeReasonCode',
      },
      {
        name: counterpart('globalTranslate.timeline.amount'),
        displayType: 'CURRENCY',
        columnKey: 'DisputeAmount',
      }
    ],
    messageData: {
      name: counterpart('globalTranslate.timeline.incomingMemberMessage'),
      displayType: 'STRING',
      columnKey: 'MemberMessage',
    }

  }
}

export function getAddInfoSectionData() {
  initCommonTranslate();
  return {
    eventCode: 'ADDITIONAL_INFORMATION',
    isVertical: true,
    dataColumns: [
      {
        name: counterpart('globalTranslate.timeline.stage'),
        displayType: 'STAGE',
        columnKey: '',
      },
      {
        name: counterpart('globalTranslate.timeline.reasonCode'),
        displayType: 'REASON_CODE',
        columnKey: 'DisputeReasonCode',
      },
      {
        name: counterpart('globalTranslate.timeline.amount'),
        displayType: 'CURRENCY',
        columnKey: 'DisputeAmount',
      }
    ],
    messageData: {
      name: counterpart('globalTranslate.timeline.incomingMemberMessage'),
      displayType: 'STRING',
      columnKey: 'MemberMessage',
    }
  }  
}

export function getActionSectionData(eventCode) {
  initCommonTranslate();
  return [
    {
      eventCode: 'RESPONSE_TO_ISSUER',
      isVertical: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.acquirerResponse'),
          displayType: 'STRING',
          columnKey: 'AcquirerResponse',
        },
        {
          name: counterpart('globalTranslate.timeline.subReason'),
          displayType: 'STRING',
          columnKey: 'SubReason',
          isOptional: true,
        },
        {
          name: counterpart('globalTranslate.timeline.outgoingMemberMessage'),
          displayType: 'STRING',
          columnKey: 'MemberMessage',
          isLastColumn: true,
        }
      ]
    },
    {
      eventCode: 'UNABLE_TO_DEFEND',
      isVertical: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.acquirerResponse'),
          displayType: 'STRING',
          columnKey: 'AcquirerResponse',
        },
        // {/*NOTE : Based on Discussion : We don't need resolution ,OMM fulfills the same requirement  */
        //   name: counterpart('globalTranslate.timeline.resolution'),
        //   displayType: 'STRING',
        //   columnKey: 'LiabilityInfo',
        // },
        {
          name: counterpart('globalTranslate.timeline.outgoingMemberMessage'),
          displayType: 'STRING',
          columnKey: 'MemberMessage',
          isLastColumn: true,
        }
      ]
    },
    {
      eventCode: 'WRITE_OFF_GOODWILL',
      isVertical: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.resolution'),
          displayType: 'STRING',
          columnKey: 'LiabilityInfo',
        },
        {
          name: counterpart('globalTranslate.timeline.outgoingMemberMessage'),
          displayType: 'STRING',
          columnKey: 'MemberMessage',
          isLastColumn: true,
        }
      ]
    },
    {
      eventCode: 'CASE_CLOSE',
      isVertical: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.reasonForClosing'),
          displayType: 'NOTE',
          columnKeyinternal: 'CloseCaseReason',
          columnKeyExternal: 'ExternalCloseCaseReason',
          isLastColumn: true,
        }
      ]
    },
    {
      eventCode: 'UNABLE_TO_FULFILL',
      isVertical: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.acquirerResponse'),
          displayType: 'STRING',
          columnKey: 'AcquirerResponse',
          isLastColumn: true,
        },
        {
          name: counterpart('globalTranslate.timeline.outgoingMemberMessage'),
          displayType: 'STRING',
          columnKey: 'MemberMessage',
          isLastColumn: true,
        }
      ]
    },
    {
      eventCode: 'CONFIRMATION_DECISIONS',
      isVertical: false,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.decisionStatus'),
          displayType: 'STRING',
          columnKey: 'status',
        },
        {
          name: counterpart('globalTranslate.timeline.decisionAmount'),
          displayType: 'CURRENCY',
          columnKey: 'DisputeAmount',
        }
      ],
      reason: {
        name: counterpart('globalTranslate.timeline.reason'),
        displayType: 'STRING',
        columnKey: 'Description',
      }
    },
    {
      eventCode: 'TRANSFER_CASE',
      isVertical: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.purposeOfTransfer'),
          displayType: 'STRING',
          columnKey: 'TransferReasonCodeDesc',
        },
        {
          name: counterpart('globalTranslate.timeline.transferTo'),
          displayType: 'STRING',
          columnKey: 'Transferred To',
        },
        {
          name: counterpart('globalTranslate.timeline.comments'),
          displayType: 'STRING',
          columnKey: 'DisputeComments',
          isLastColumn: true,
        }
      ]
    },
    {
      eventCode: 'RESPOND_TO_CARD_BRAND',
      isVertical: false,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.acquirerResponse'),
          displayType: 'STRING',
          columnKey: 'AcquirerResponse',
        },
        {
          name: counterpart('globalTranslate.timeline.caseAmount'),
          displayType: 'CURRENCY',
          columnKey: 'CaseAmount',
        }
      ],
      reason: {
        name: counterpart('globalTranslate.timeline.outgoingMemberMessage'),
        displayType: 'STRING',
        columnKey: 'MemberMessage',
      }
    },
    {
      eventCode: 'MERCHANT_DENY',
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.description'),
          displayType: 'STRING',
          columnKey: 'Description',
        },
        {
          name: counterpart('globalTranslate.timeline.caseType'),
          displayType: 'STAGE',
          columnKey: '',
        },
        {
          name: counterpart('globalTranslate.timeline.date'),
          displayType: 'DATE',
          columnKey: '',
        }],
    },
    {
      eventCode: 'CHALLENGE',
      isHorizantal: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.description'),
          displayType: 'STRING',
          columnKey: 'Description',
        },
        {
          name: counterpart('globalTranslate.timeline.caseType'),
          displayType: 'STAGE',
          columnKey: '',
        },
        {
          name: counterpart('globalTranslate.timeline.date'),
          displayType: 'DATE',
          columnKey: '',
          isLastColumn: true,
        },
      ],
      remedyInfo : [{
          name: counterpart('globalTranslate.timeline.response'),
          displayType: 'REMEDY',
          columnKey: '',
          value: counterpart('globalTranslate.timeline.responseValue'),
          isNewRow:true,
        },
        {
          name: counterpart('globalTranslate.timeline.responseType'),
          displayType: 'REMEDY',
          columnKey: '',
          isLastColumn: true,
          value: counterpart('globalTranslate.timeline.responseTypeValue'),
          isLastColumn: true,
        },     
      ],
    },
    {
      eventCode: 'MERCH_UNABLE_TO_FULFILL',
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.description'),
          displayType: 'STRING',
          columnKey: 'Description',
        },
        {
          name: counterpart('globalTranslate.timeline.caseType'),
          displayType: 'STAGE',
          columnKey: '',
        },
        {
          name: counterpart('globalTranslate.timeline.date'),
          displayType: 'DATE',
          columnKey: '',
        }],
    },
    {
      eventCode: 'MERCHANT_ACCEPT_LIABILITY',
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.description'),
          displayType: 'STRING',
          columnKey: 'Description',
        },
        {
          name: counterpart('globalTranslate.timeline.caseType'),
          displayType: 'STAGE',
          columnKey: '',
        },
        {
          name: counterpart('globalTranslate.timeline.date'),
          displayType: 'DATE',
          columnKey: '',
        }],
    },
    {
      eventCode: 'MERCHANT_REJECTED_CASE',
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.description'),
          displayType: 'STRING',
          columnKey: 'Description',
        },
        {
          name: counterpart('globalTranslate.timeline.caseType'),
          displayType: 'STAGE',
          columnKey: '',
        },
        {
          name: counterpart('globalTranslate.timeline.date'),
          displayType: 'DATE',
          columnKey: '',
        }],
    },
    {
      eventCode: 'FULFILL_REQUEST',
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.description'),
          displayType: 'STRING',
          columnKey: 'Description',
        },
        {
          name: counterpart('globalTranslate.timeline.caseType'),
          displayType: 'STAGE',
          columnKey: '',
        },
        {
          name: counterpart('globalTranslate.timeline.date'),
          displayType: 'DATE',
          columnKey: '',
        }],
    },
    {
      eventCode: 'PURSUE_CASE_FILING',
      isVertical: false,
      dataColumns: [
        {
          name: 'Case Filling Type',
          displayType: 'STRING',
          columnKey: 'caseFilingType',
        },
        {
          name: 'Case Filling Amount',
          displayType: 'CURRENCY',
          columnKey: 'caseFilingAmount',
        },
        {
          name: 'Date Of Violation',
          displayType: 'DATE_ONLY',
          columnKey: 'dateOfViolation',
        },
        {
          name: 'Primary Rule Violated',
          displayType: 'STRING',
          columnKey: 'primaryRuleViolated',
        },
        {
          name: 'Did Financial Loss Occured',
          displayType: 'INDICATOR',
          columnKey: 'didFinancialLossoccured',
        },
        {
          name: 'Financial Loss Explanation',
          displayType: 'STRING',
          columnKey: 'financialLossoccuredDesc',
        },
        {
          name: 'Date Of Discovery',
          displayType: 'DATE_ONLY',
          columnKey: 'dateOfDiscovery',
        },
        {
          name: 'Good Faith Type',
          displayType: 'STRING',
          columnKey: 'goodFaithType',
        },
        {
          name: 'Good Faith Response Date',
          displayType: 'DATE_ONLY',
          columnKey: 'goodFaithResponseDate',
        },
        {
          name: 'Good Faith Amount',
          displayType: 'CURRENCY',
          columnKey: 'goodFaithAmount',
        },
        {
          name: 'Reason for Good Faith',
          displayType: 'STRING',
          columnKey: 'reasonForGoodFaith',
          isLastColumn: true,
        },
        {
          name: 'Reason For Filling',
          displayType: 'STRING',
          columnKey: 'reasonForFiling',
          isLastColumn: true,
        }, {
          name: 'Initiate Pre-Compliance',
          displayType: 'STRING',
          columnKey: 'initiatePreCompliance',
          isLastColumn: true,
        }
      ]
    }, {
      eventCode: 'UNABLE_TO_FULFILL',
      isVertical: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.acquirerResponse'),
          displayType: 'STRING',
          columnKey: 'AcquirerResponse',
          isLastColumn: true,
        },
        {
          name: counterpart('globalTranslate.timeline.outgoingMemberMessage'),
          displayType: 'STRING',
          columnKey: 'MemberMessage',
          isLastColumn: true,
        }
      ]
    },
    {
      eventCode: 'CB_API_RES_ACK',
      isVertical: false,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.decisionStatus'),
          displayType: 'STRING',
          columnKey: 'status',
        }
      ],
      reason: {
        name: counterpart('globalTranslate.timeline.reason'),
        displayType: 'STRING',
        columnKey: 'Description',
      }
    },
    {
      eventCode: 'MANUALLY_PROCESSED',
      isVertical: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.caseNote'),
          displayType: 'NOTE',
          columnKeyinternal: 'Description',
          columnKeyExternal: 'ExternalDescription',
          isLastColumn: true,
        }
      ]
    },
    {
      eventCode: 'ISSUER_DOC_REQUEST_EVENT',
      isVertical: true,
      dataColumns: [
        {
          name: counterpart('globalTranslate.timeline.acquirerRequest'),
          displayType: 'NOTE',
          columnKeyinternal: 'Description',
          isLastColumn: true,
        }
      ]
    }
  ].find((actionMetaData) => {
    return actionMetaData.eventCode === eventCode;
  });
}

export function getDocumentSectionData() {
  initCommonTranslate();
  return {
    dataColumns: [
      {
        name: counterpart('globalTranslate.timeline.file'),
        displayType: 'DOCUMENT',
        columnKey: 'docName',
      },
      {
        name: counterpart('globalTranslate.timeline.description'),
        displayType: 'STRING',
        columnKey: 'description',
      },
      {
        name: counterpart('globalTranslate.timeline.source'),
        displayType: 'STRING',
        columnKey: 'source',
      }
    ]
  }

}

export function getCaseNoteSectionData() {
  initCommonTranslate();
  return {
    notesData: [
      {
        name: counterpart('globalTranslate.timeline.caseNote'),
        displayType: 'STRING',
        columnKey: 'NoteText',
      },
      {
        name: counterpart('globalTranslate.timeline.caseNote'),
        displayType: 'STRING',
        columnKey: 'ExternalNoteText',
      },
    ]

  }
}

export function getReasonAdditionalReviewSectionData() {
  initCommonTranslate();
  return {
    reasonAdditionalData: [
      {
        name: counterpart('globalTranslate.timeline.caseNote'),
        displayType: 'STRING',
        columnKey: 'NoteText',
      },
    ]

  }
}